import DeleteIcon from '@mui/icons-material/Delete';
import RestoreIcon from '@mui/icons-material/Restore';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button } from '@mui/material';
import {
  ChipField,
  Labeled,
  SimpleShowLayout,
  UpdateButton,
  useRecordContext,
} from 'react-admin';
import ReactJson from 'react-json-view';

export const AIPromptTagsCommandPanel = ({
  onEdit,
}: {
  onEdit?: (id: string) => void;
}) => {
  const record = useRecordContext();

  return (
    <SimpleShowLayout record={record}>
      {record.tagExpression && (
        <Labeled label="Tag Expression">
          <ReactJson
            src={record.tagExpression}
            theme="monokai"
            displayDataTypes={false}
            enableClipboard={true}
            collapsed={2}
          />
        </Labeled>
      )}
      {record.tagField && (
        <Labeled label="Tag Field">
          <ChipField source="tagField" />
        </Labeled>
      )}
      <Box display="flex" gap={1}>
        <Button
          startIcon={<EditIcon />}
          size="small"
          color="primary"
          onClick={() => onEdit?.(record.id)}
          sx={{ textTransform: 'uppercase', fontWeight: 500 }}
        >
          Edit
        </Button>
        {!record.deletedAt && (
          <UpdateButton
            resource="aiPromptTags"
            label="Delete"
            type="button"
            color="error"
            icon={<DeleteIcon />}
            confirmTitle="Are you sure?"
            confirmContent="This will delete the tag from the system. It will still be available in the database."
            mutationMode="pessimistic"
            data={{
              deletedAt: new Date(),
            }}
          />
        )}
        {!!record.deletedAt && (
          <UpdateButton
            resource="aiPromptTags"
            label="Restore"
            type="button"
            color="primary"
            icon={<RestoreIcon />}
            mutationMode="pessimistic"
            confirmTitle="Are you sure?"
            confirmContent="This will restore the tag to the system. It will be available in the admin interface."
            data={{
              deletedAt: null,
            }}
          />
        )}
      </Box>
    </SimpleShowLayout>
  );
};
